import { render } from "./MediaCard.vue?vue&type=template&id=67e4f60e&scoped=true"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"

import "./MediaCard.vue?vue&type=style&index=0&id=67e4f60e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e4f60e"]])

export default __exports__